import { FC, useState } from 'react'
import { DateRangePicker, isInclusivelyAfterDay, FocusedInputShape } from 'react-dates'
import useCheckBreakpoint from 'lib/checkBreakpoint'
import { useTranslation } from 'next-i18next'

import moment from 'moment'
moment.locale('ja')

import styles from './DateRangeCalendarSimpleComponent.module.scss'
import { calendarWeekHeader } from 'utils/calendar'

interface Props {
  onPressCloseModalRequest: () => void
  selectedDate: {
    startDate: moment.Moment | null
    endDate: moment.Moment | null
  }
  setSelectedDate: ({ startDate, endDate }) => void
  page?: string
  locale?: string
}

const DateRangeCalendarComponent: FC<Props> = ({
  onPressCloseModalRequest,
  selectedDate,
  setSelectedDate,
  page,
}: Props): JSX.Element => {
  const [focused, setFocused] = useState<FocusedInputShape>(null)
  const { isMobile } = useCheckBreakpoint()
  const { i18n } = useTranslation()

  const placeHolderStart = moment(new Date()).format('MM/DD')
  const placeHolderEnd = placeHolderStart

  return (
    <DateRangePicker
      readOnly
      numberOfMonths={isMobile ? 1 : 2}
      startDatePlaceholderText={placeHolderStart}
      endDatePlaceholderText={placeHolderEnd}
      monthFormat={i18n.language === 'en' ? 'YYYY MMMM' : 'YYYY[年]MM[月]'}
      startDate={selectedDate.startDate}
      endDate={selectedDate.endDate}
      startDateId="start"
      endDateId="end"
      focusedInput={focused}
      onDatesChange={({ startDate, endDate }) => {
        setSelectedDate({ startDate: startDate, endDate: endDate })
      }}
      onFocusChange={(focusedInput) => setFocused(focusedInput)}
      verticalSpacing={0}
      navPrev={<div className={styles.prev} />}
      navNext={<div className={styles.next} />}
      isOutsideRange={(day) =>
        day.isSameOrAfter(moment().add(3, 'month')) || !isInclusivelyAfterDay(day, moment())
      }
      hideKeyboardShortcutsPanel
      renderCalendarInfo={() => undefined}
      minimumNights={0}
      displayFormat="MM/DD"
      customArrowIcon={<span>-</span>}
      renderWeekHeaderElement={(day) => {
        return <div className={styles.weekHeader}>{calendarWeekHeader?.[day]?.[i18n.language]}</div>
      }}
    />
  )
}

export default DateRangeCalendarComponent
